import { Password } from '@or-sdk/password';

import { useAuthStore } from '@/stores/auth/auth';

import config from '../config';

export default new Password({
  sdkApiUrl: `${config.SDK_API_URL}`,
  token: () => useAuthStore().reactiveToken as string,
});
